module.exports = __webpack_public_path__ + "img/KinokoTable69.64f7d6ad.jpg";